import { useTheme } from "styled-components";
import { getMobileSectionTitleProps } from "features/dashboard/common/styles";
import DashboardBotsCard from "features/dashboard/MobileDashboard/Bots/DashboardBotsCard";
import Title from "common/Typography/Title";
import {
  BOTS_SUMMARY_CARD_HEIGHT,
  NEW_LOOK_BOTS_SUMMARY_CARD_HEIGHT,
} from "features/dashboard/common/constants";
import FlatList from "common/Lists/FlatList";
import React from "react";
import useBotsSummary from "features/dashboard/MobileDashboard/Bots/useBotsSummary";
import { BotSummaryData } from "features/dashboard/common/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const BotsSummaryCards = () => {
  const { isNewLook } = useTheme();
  const sectionTitleProps = getMobileSectionTitleProps(isNewLook);
  const { sortedBots, isLoading } = useBotsSummary();
  const { t } = useTypedTranslation(LanguageNameSpaces.DASHBOARD);

  const renderBotsCard = ({ item }: { item: BotSummaryData }) => {
    return <DashboardBotsCard data={item} key={item.botType} />;
  };

  const list = (
    <FlatList<BotSummaryData>
      data={sortedBots || []}
      horizontal={true}
      renderContent={renderBotsCard}
      itemHeight={
        isNewLook ? NEW_LOOK_BOTS_SUMMARY_CARD_HEIGHT : BOTS_SUMMARY_CARD_HEIGHT
      }
      loading={isLoading}
    />
  );

  return (
    <>
      <Title {...sectionTitleProps} style={{ padding: "0 16px 8px" }}>
        {t("bots.section_title")}
      </Title>
      {list}
    </>
  );
};

export default React.memo(BotsSummaryCards);
